import React from "react";
import { PRINCIPIOS } from "@/content/site";
import { PQ, PQ_IMG } from "@/content/pesquisa";
import { Container, Eyebrow, Body, Reveal, EpistemicTag } from "@/components/site/ui";

// Limites da percepção + fatores humanos (Home).
const LimitesHumano = () => (
    <section data-testid="home-limites" data-section-id="limites" className="relative bg-[#F2EFE5] text-[#0E2018] overflow-hidden">
        <div aria-hidden="true" className="absolute inset-0 paper-grain" />
        <div className="relative grid grid-cols-1 lg:grid-cols-12">
            <Container className="lg:col-span-7 py-24 md:py-32 lg:pr-16 lg:pl-20 xl:pl-36 max-w-none">
                <Reveal>
                    <Eyebrow light>Fatores humanos e limites da percepção</Eyebrow>
                    <h2 data-testid="humano-title" className="font-serif font-light text-[30px] sm:text-[38px] leading-[1.1] tracking-[-0.01em]">{PRINCIPIOS.humano}</h2>
                    <Body light className="mt-6 max-w-2xl">{PQ.humano.text}</Body>
                </Reveal>
                <Reveal delay={150} className="mt-14 pt-10 border-t border-[#0E2018]/15">
                    <div className="flex flex-wrap items-center gap-3 mb-5">
                        <Eyebrow light className="!mb-0">{PQ.caverna.eyebrow}</Eyebrow>
                        <EpistemicTag tipo="lente-filosofica" light />
                    </div>
                    <p data-testid="limites-pergunta" className="font-serif font-light text-[22px] sm:text-[26px] leading-[1.35] text-balance">{PQ.caverna.pergunta}</p>
                    <Body light className="mt-6 max-w-2xl">{PQ.caverna.text}</Body>
                </Reveal>
            </Container>
            <div className="relative lg:col-span-5 min-h-[40svh] lg:min-h-full">
                <img src={PQ_IMG.caverna} alt="Sombras humanas projetadas por fogo na parede de uma caverna" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            </div>
        </div>
    </section>
);

export default LimitesHumano;
